export default "__VITE_ASSET__205c74ab__"